import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        position: 'absolute',
        top: 40,
        flex: 1,
        width: '100%',
        height: '100%'
    },
    textContainer: {
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        padding: '2%',
        paddingRight: '4%'
    },
    text: {
        fontFamily: Theme.mediumFont,
        fontSize: Theme.fontSizes.button,
        color: '#FFFFFF'
    },
    counter: {
        fontFamily: Theme.ultraFont,
        fontSize: Theme.fontSizes.button,
        color: '#FFFFFF',
        paddingLeft: 5
    }
};

export default StyleSheet.create(baseStyles as any);
